<template>
  <div>
    <!-- 验证码登录 -->
    <el-form
      :model="inputTo"
      :rules="rules"
      class="pad-top20 width46 margin-auto pad-bot10"
    >
      <el-form-item
        prop="phonenumber"
        class="flex-input margin-auto buttom-none width100"
      >
        <el-input
          size="medium"
          type="text"
          class="el-input"
          v-model="inputTo.phonenumber"
          placeholder="手机号码"
          ><i
            slot="prefix"
            class="el-icon-s-custom"
            style="margin-top: 12px"
          ></i
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="margin-auto flex-betweennowrap width46">
      <el-input
        size="medium"
        type="text"
        class="el-input width66 cursorpointer"
        v-model="verificationcode"
        placeholder="图形验证码"
      >
      </el-input>
      <img class="width27 cursorpointer" @click="Refresh()" :src="img" alt="" />
    </div>
    <div class="margin-auto flex-betweennowrap pad-top20 width46">
      <el-input
        size="medium"
        type="text"
        class="el-input width66"
        v-model="SMSverification"
        placeholder="短信验证码"
      >
      </el-input>
      <div
        v-if="changecont"
        class="
          width27
          verification
          color-87
          lineheight40
          textalign-center
          f14
          cursorpointer
        "
        @click="SendSMS()"
      >
        获取验证码
      </div>
      <div
        v-if="changecontspan"
        class="
          width27
          verification
          color-87
          lineheight40
          textalign-center
          f14
          cursorpointer
        "
        @click="SendSMS()"
      >
        重新获取({{ time }}s)
      </div>
    </div>
    <div class="width46 margin-auto margin-top20">
      <button
        class="main-imgt textalign-center buttom-none color-fff cursorpointer"
        :style="{
          background:
            inputTo.phonenumber == 0
              ? '#e7e9ef'
              : '#52C6CC' && verificationcode == 0
              ? '#e7e9ef'
              : ' #52C6CC' && SMSverification == 0
              ? '#e7e9ef'
              : ' #52C6CC',
          color:
            inputTo.phonenumber == 0
              ? '#969EAC'
              : '#fff' && verificationcode == 0
              ? '#969EAC'
              : '#fff' && SMSverification == 0
              ? '#969EAC'
              : '#fff',
        }"
        @click="SMSVerifica()"
      >
        登 录
      </button>
    </div>
    <p class="width46 margin-auto textalign-center f14 cursorpointer">
      <span>还没有账号？</span
      ><span @click="righten" style="color: #52c6cc">立即注册</span>
    </p>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { Getverification, SendSMS, authloginsms } from "@/api/login/login.api";
// 外部mixin——主要负责表单校验
import formMixin from "./mixins/formMixin.js";
import BUS from "@/BUS/BUS";
import VueCookie from "vue-cookie";
export default {
  mixins: [formMixin],
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      inputTo: {
        phonenumber: "",
        phoneNumber: "",
      },
      verificationcode: "",
      SMSverification: "",
      img: "",
      changecont: true,
      changecontspan: false,
      time: 60,
    };
  },
  methods: {
    // 发送登录短信
    SendSMS() {
      if (this.inputTo.phonenumber == "" || this.verificationcode == "") {
        return;
      } else {
        // 发送短信
        SendSMS({
          verify_code: this.verificationcode,
          mobile: this.inputTo.phonenumber,
        }).then((res) => {
          if (res.data.code == 200) {
            // 成功
            if (res.data.code == 200) {
              this.changecont = false;
              this.changecontspan = true;
              var timer = setInterval(() => {
                this.time--;

                if (this.time == 0) {
                  clearInterval(timer);
                  this.time = 60;
                  Getverification().then((res) => {
                    this.img = res.data.data;
                  });
                  this.verificationcode = null;
                }
              }, 1000);
              this.$message({
                showClose: true,
                message: "获取验证码成功",
                type: "success",
              });
            }
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    // 图片验证码刷新
    Refresh() {
      Getverification().then((res) => {
        this.img = res.data.data;
      });
    },
    // 验证码登录
    SMSVerifica() {
      authloginsms({
        mobile: this.inputTo.phonenumber,
        code: this.SMSverification,
      }).then((res) => {
        if (res.data.code == 200 && res.data.msg == "登录成功") {
          window.localStorage.setItem("token", res.data.data.token);
          window.sessionStorage.setItem("token", res.data.data.token);
          let token = res.data.data.token;
          VueCookie.set("token", token, 14 * 24 * 60 * 60);
          window.sessionStorage.setItem("phon", this.inputTo.phonenumber);
          this.$router.push("/home");
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    righten() {
      BUS.$emit("righten", 111);
    },
  },
  components: {},

  created() {
    // 获取图片验证码
    Getverification().then((res) => {
      this.img = res.data.data;
    });
    this.classStatu = false;
    this.classStatus = true;
    this.logingpassword = false;
    this.loginrigest = true;
  },
  mounted() {
    // 获取图片验证码
    Getverification().then((res) => {
      this.img = res.data.data;
    });
    this.classStatu = false;
    this.classStatus = true;
    this.logingpassword = false;
    this.loginrigest = true;
  },
};
</script>

<style scoped>
.main-imgt {
  width: 100%;
  margin: 20px auto 20px;
  height: 46px;
  background: #e7e9ef;
  border-radius: 23px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #969eac;
  text-align: center;
  line-height: 14px;
  font-weight: 500;
}

.verification {
  background: #52c6cc;
  border-radius: 23px;
  color: #fff;
}
.el-input >>> .el-input__inner {
  border-radius: 4px;
  height: 40px;
  border: 1px solid #efefef;
  outline: none;
  background: #f6f7fb;
  /* line-height: 40px; */
  /* margin-bottom: 10px; */
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>